// extracted by mini-css-extract-plugin
export default {"modalWrap":"TaskModalView_modalWrap__GZ9-E","modalStyles":"TaskModalView_modalStyles__1J30a","styledBox":"TaskModalView_styledBox__vgurH","close":"TaskModalView_close__Hj9Wq"};